import { Spinner } from "../Spinner/Spinner";

import style from "./SpinnerCenter.module.css";

export const SpinnerCenter = () => (
  <div className={style.container}>
    <Spinner />
  </div>
);
